export default __webpack_public_path__ + "static/crispin-glover-e003b1cc3f3ab3836a0924883d854f70.svg";